namespace GeniuzPOS.Inventory {
    export class IcStockReturnInDtColumns {
        static columnsKey = 'Inventory.IcStockReturnInDt';
    }
}
